<template>
  <v-dialog
    :value="value"
    :fullscreen="isMobile()"
    width="800px"
    @click:outside.stop="$emit('close')"
    @keydown.esc="$emit('close')"
    scrollable
  >
    <v-card flat tile>
      <v-card-title>
        {{ $t('workSchedules.tempHistory')}}
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-container fluid class="pa-0">
        <v-layout>
          <v-row class="pa-0 ma-0">
            <v-col class="pa-0">
              <v-row class="ma-0">
                <v-card-subtitle>
                  <v-icon>person</v-icon>
                  {{ $t('tableHeaders.name') }}: <span class="font-weight-bold">{{ assignment.employeeName }}</span>
                </v-card-subtitle>
                <v-card-subtitle>
                  <v-icon>work</v-icon>
                  {{ $t('tableHeaders.position') }}: <span class="font-weight-bold">{{ assignment.description }}</span>
                </v-card-subtitle>
              </v-row>
              <v-divider/>
              <v-row class="ma-0">
                <v-container fluid class="pa-0">
                  <v-layout>
                    <v-row class="ma-0">
                      <v-col>
                        <v-card>
                          <v-data-table
                            :headers="tableHeaders"
                            :items="assignment.tempWorkScheduleAssignmentRequests"
                            :no-data-text="`${$t('manager.noHistoryAvailable')}`"
                            disable-sort
                            disable-pagination
                            hide-default-footer
                          >
                            <template v-slot:item.workSchedule="{ item }">
                              {{ item.workScheduleExternalName }}
                            </template>
                            <template v-slot:item.startDate="{ item }">
                              {{ item.startDate }}
                            </template>
                            <template v-slot:item.endDate="{ item }">
                              {{ item.endDate }}
                            </template>
                            <template v-slot:item.ecSynchronisationStatus="{ item }">
                              <ECSynchronisationStatusIndicator
                                :status="item.ecSynchronisationStatus"
                                :synchronisation-failure-text="item.errorMessage"
                              />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-container>
              </v-row>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from '@/constants';

import displayAdaptable from '@/mixins/displayAdaptable';

import ECSynchronisationStatusIndicator from '@/components/ECSynchronisationStatusIndicator.vue';

export default {
  name: 'ApprovalsWorkScheduleAssignmentHistoryDialog',
  components: { ECSynchronisationStatusIndicator },
  props: {
    value: Boolean,
    assignment: Object,
  },

  mixins: [displayAdaptable],

  data() {
    return {
      tableHeaders: [
        {
          text: this.$t('workSchedules.ws'),
          value: 'workSchedule',
          align: 'start',
        },
        {
          text: this.$t('notifications.startDate'),
          value: 'startDate',
          align: 'start',
        },
        {
          text: this.$t('notifications.endDate'),
          value: 'endDate',
          align: 'start',
        },
        {
          text: this.$t('workSchedules.syncStatus'),
          value: 'ecSynchronisationStatus',
          align: 'center',
        },
      ],
    };
  },

  methods: {
    isEcSynchronisationStatusPending(status) {
      return status === constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING;
    },

    getEcSynchronisationStatusColour(status) {
      switch (status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return 'success';
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return 'primary';
        default: return 'error';
      }
    },

    getEcSynchronisationStatusIcon(status) {
      switch (status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return 'cloud_done';
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return 'cloud_circle';
        default: return 'cloud_off';
      }
    },

    getEcSynchronisationTooltip(status) {
      switch (status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return 'Synchronised with EC';
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return 'Synchronisation with EC pending';
        default: return 'Synchronisation with EC failed';
      }
    },
  },
};
</script>

<style scoped>

</style>
